/**
 * A human label for a user, surfaced wherever an identity is displayed now that
 * `email` can be null (Hotel Groups — username-only staff).
 *
 * Precedence: full name → username → email → `'—'`. Mirrors the backend
 * `userDisplayName` helper (apps/api/.../users/user-display.ts) so the client
 * falls back identically when a read DTO doesn't already carry a `displayName`.
 * Never returns null/blank, so a null-email/username row can't render as
 * undefined or an empty cell.
 */
export function userDisplayName(user: {
  firstName?: string | null;
  lastName?: string | null;
  username?: string | null;
  email?: string | null;
}): string {
  const fullName = [user.firstName, user.lastName]
    .filter(Boolean)
    .join(' ')
    .trim();
  return fullName || user.username || user.email || '—';
}

/**
 * The bare login identifier for a user — username preferred over email (a
 * username-only staff member has no email). Falls back to `'—'`. Use in
 * "Identifier"/attribution columns where the raw handle (not the full name) is
 * wanted.
 */
export function userIdentifier(user: {
  username?: string | null;
  email?: string | null;
}): string {
  return user.username || user.email || '—';
}
